import React, {useContext} from "react";
import {GlobalDataContext} from "../../../contexts/GlobalDataContext";
import FillableCircle from "../../d3/FillableCircle";
import {SkeletonLineF, StyledSkeletonCircle} from "../../SkeletonLoader/SkeletonLoaders";
import withLoadingAnimation from "../../AnimationWrapper/AnimationWrapper";
import { RankingsAndLevelsContext } from "../../../contexts/RankingsAndLevelsContext";
import Colors from "../../../assets/colors/Colors";

const RankingComponent: React.FC<{title: any, rankingValue: any }> = ({title, rankingValue}) => {
    // @ts-ignore
    const { allDataLoaded } = useContext(GlobalDataContext);
    // @ts-ignore
    const { isLife } = useContext(RankingsAndLevelsContext);

    return (
        <React.Fragment>
            {
                withLoadingAnimation(
                    <FillableCircle rank={rankingValue || 1} isLife={ isLife } />,
                    <StyledSkeletonCircle height={124} width={124} />,
                    allDataLoaded
                )
            }

            <div
              className='fillableCircleInfo'
              style={{
                color: isLife ? Colors.fontWhite : Colors.fontGray
              }}
            >
                <div>{title}</div>
                {
                    withLoadingAnimation(
                        <div style={{ fontSize: 67, fontFamily: 'DMSans-Light' }}>{rankingValue}°</div>,
                        <SkeletonLineF />,
                        allDataLoaded
                    )
                }
            </div>
        </React.Fragment>
    )
};

export default RankingComponent;
